import { useParams } from "react-router";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { PositionsByArea } from "@/routes/processes/[processId]/vbs/work-orders/execution/[workOrderId]/treatment/_components/positions-by-area";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";

export function WorkOrderExecutionTreatmentRoute() {
  const { workOrderId } = useParams();
  const { data } = useVbsWorkOrderShowQuery({ id: workOrderId! });

  // The treatment is a document of its own inside the work order's page.
  // Its errors get a scope of their own.
  return (
    <ErrValidationFailedContextProvider>
      <PositionsByArea workOrder={data!} />
    </ErrValidationFailedContextProvider>
  );
}
